import * as React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@wix/design-system';
import s from './SaleBanner.scss';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import classNames from 'classnames';

interface PermanentSaleBannerContentProps {
    rootStore: RootStore;
}

const PermanentSaleBannerContentComp: React.FC<
    PermanentSaleBannerContentProps
> = ({ rootStore }) => {
    const { isSecondUpgrade, isChangePlan } = rootStore.appStore;
    const { theme } = usePageModeContext();

    const bannerKey = isSecondUpgrade || isChangePlan
        ? 'premium-purchase-plan.header.permanent_50.second_upgrade.banner'
        : 'premium-purchase-plan.header.permanent_50.banner';

    return (
        <Text weight='bold' className={s.saleDiscountColor} light={false}>
            <Trans i18nKey={bannerKey}>
                <span className={classNames(s.saleDiscountColor, theme)}>Save 50%</span>
            </Trans>
        </Text>
    );
};

export const PermanentSaleBannerContent = withInjectedRootStore(
    PermanentSaleBannerContentComp,
);
